export default "__VITE_ASSET__CckdFdJu__"